import React, { Component } from 'react';
import { tags } from './config';
import { withTranslation } from 'react-i18next';
import GoogleSearchConsole from './components/GoogleSearchConsole';
import BrandEntities from './components/BrandEntities';
import Entities from './components/Entities';
import { getCredits, getProjects } from '../create/query';
import { getDomainsApi, getPromptCredits } from './query';
import AiTrackingAdd from '../create';
import ExistingTopics from './components/ExistingTopics';
import { getData } from '../PromptManager/query';
import { FANOUT_PROMPTS_STORAGE_KEY } from '../prompt/components/FanoutQueries/additionalBox';

class AiTrackingPromptGenerator extends Component {
    constructor(props) {
        super();
        this.addActive = this.addActive.bind(this);
        this.onChangeTags = this.onChangeTags.bind(this);
        this.getProjectsData = this.getProjectsData.bind(this);
        this.getPromptCounts = this.getPromptCounts.bind(this);
        this.getBalance = this.getBalance.bind(this);
        this.getTrackedPrompts = this.getTrackedPrompts.bind(this);
        this.getDomains = this.getDomains.bind(this);

        try {
            this.linkedAccounts = JSON.parse(document.getElementById('linkedAccounts').textContent);
        } catch (e) {
            console.log('e', e);
        }

        this.url = new URL(window.location);
        let view = this.url.searchParams.get('view');
        this.projectId = this.url.searchParams.get('projectId');

        // Consume the queries stashed by the fanout "Track Prompts" action (if any)
        // so the manual step can pre-fill them. Read once and clear immediately so
        // a later refresh doesn't re-inject stale prompts.
        this.initialPrompts = [];
        try {
            const storedPrompts = JSON.parse(sessionStorage.getItem(FANOUT_PROMPTS_STORAGE_KEY));
            if (Array.isArray(storedPrompts) && storedPrompts.length) {
                this.initialPrompts = storedPrompts;
                sessionStorage.removeItem(FANOUT_PROMPTS_STORAGE_KEY);
            }
        } catch (e) {
            console.log('e', e);
        }

        if (!view) {
            // Land on the manual step when arriving with fanout prompts to add.
            view = this.initialPrompts.length ? 'manual' : tags(props.t)[0].id;
        }
        this.state = {
            prompt: '',
            type: view,
            projectLoader: false,
            projects: [],
            promptCredits: 0,
            available_credits: 0,
            getCreditsLoader: false,
            balanceLoader: false,
            updateExistingPrompts: 0,
            alreadyTrackedPrompts: [],
            domains: [],
            domainsLoader: false,
        };
    }

    addActive(id) {
        return this.state.type === id;
    }

    onChangeTags(id) {
        this.url.searchParams.set('view', id);
        history.pushState({}, '', this.url);
        let updateExistingPrompts = this.state.updateExistingPrompts ?? 0;

        if (id === 'existing_prompts') {
            updateExistingPrompts++;
        }

        this.setState({
            type: id,
            updateExistingPrompts,
        });
    }

    async getPromptCounts() {
        try {
            this.setState({
                getCreditsLoader: true,
            });
            const response = await getPromptCredits();
            const data = await response.json();
            const promptCount =
                data?.allowed_per_plan + data?.extra_allowed - data?.total_used || 0;

            this.setState({
                promptCredits: promptCount,
                getCreditsLoader: false,
            });
        } catch (err) {
            this.setState({
                promptCredits: 0,
                getCreditsLoader: false,
            });
            console.log('err', err);
        }
    }

    async getBalance() {
        try {
            this.setState({
                balanceLoader: true,
            });
            const response = await getCredits();
            const data = await response.json();
            const available_credits = data?.available_credits;
            this.setState({
                available_credits,
                balanceLoader: false,
            });
        } catch (err) {
            this.setState({
                available_credits: 0,
                balanceLoader: false,
            });
            console.log('err', err);
        }
    }

    async getDomains() {
        try {
            this.setState({
                domainsLoader: true,
            });
            const res = await getDomainsApi();
            const data = await res.json();
            this.setState({
                domains: data,
                domainsLoader: false,
            });
        } catch (err) {
            this.setState({
                domains: [],
                domainsLoader: false,
            });
            console.log('err', err);
        }
    }

    async getTrackedPrompts() {
        try {
            // get already created prompts
            const response = await getData();
            const data = await response.json();
            const prompts = data?.map((item) => item.prompt) ?? [];
            this.setState({
                alreadyTrackedPrompts: prompts,
            });
        } catch (e) {
            console.log('e', e);
        }
    }

    async componentDidMount() {
        this.getProjectsData();
        this.getPromptCounts();
        this.getBalance();
        this.getTrackedPrompts();
        this.getDomains();
    }

    async getProjectsData() {
        try {
            this.setState({
                projectLoader: true,
            });
            const response = await getProjects();
            const data = await response.json();
            this.setState({
                projectLoader: false,
                projects: data.map((item) => ({
                    label: item.name,
                    value: item.id,
                    ...item,
                })),
            });
        } catch (err) {
            console.log('err', err);
        }
    }

    render() {
        const { t } = this.props;
        return (
            <div className="ai-tracking-generator">
                <div className="ai-tracking-generator-menu">
                    {tags(t).map((tag, i, arr) => (
                        <React.Fragment key={tag.id}>
                            {i === arr.length - 1 && <div className="ai-tracking-menu-divider" />}
                            {tag.link ? (
                                <a
                                    className="ai-tracking-generator-menu-item"
                                    href={tag.link}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {t(`opportunities.tabs.${tag.id}`, { defaultValue: tag.label })}
                                </a>
                            ) : (
                                <div
                                    className={`ai-tracking-generator-menu-item ${
                                        this.addActive(tag.id) ? 'active' : ''
                                    }`}
                                    onClick={() => this.onChangeTags(tag.id)}
                                >
                                    {t(`opportunities.tabs.${tag.id}`, { defaultValue: tag.label })}
                                </div>
                            )}
                        </React.Fragment>
                    ))}
                </div>
                <div className="w-100">
                    <div
                        style={{
                            display: this.state.type === 'google_search_console' ? 'block' : 'none',
                        }}
                    >
                        <GoogleSearchConsole
                            domains={this.state.domains}
                            linkedAccounts={this.linkedAccounts}
                            promptCredits={this.state.promptCredits}
                            balanceLoader={this.state.balanceLoader}
                            getCreditsLoader={this.state.getCreditsLoader}
                            available_credits={this.state.available_credits}
                        />
                    </div>
                    <div
                        style={{
                            display:
                                this.state.type === 'brand_to_entities_to_prompts'
                                    ? 'block'
                                    : 'none',
                        }}
                    >
                        <BrandEntities
                            projectLoader={this.state.projectLoader}
                            projects={this.state.projects}
                            getProjectsData={this.getProjectsData}
                            promptCredits={this.state.promptCredits}
                            available_credits={this.state.available_credits}
                            balanceLoader={this.state.balanceLoader}
                            getCreditsLoader={this.state.getCreditsLoader}
                            moveToExistingPrompts={() => this.onChangeTags('existing_prompts')}
                        />
                    </div>
                    <div style={{ display: this.state.type === 'entities' ? 'block' : 'none' }}>
                        <Entities
                            getProjectsData={this.getProjectsData}
                            domains={this.state.domains?.filter((item) => item.active) || []}
                            projectLoader={this.state.projectLoader}
                            projects={this.state.projects}
                            promptCredits={this.state.promptCredits}
                            available_credits={this.state.available_credits}
                            balanceLoader={this.state.balanceLoader}
                            getCreditsLoader={this.state.getCreditsLoader}
                            domainsLoader={this.state.domainsLoader}
                        />
                    </div>
                    <div
                        style={{
                            display: this.state.type === 'existing_prompts' ? 'block' : 'none',
                        }}
                    >
                        <ExistingTopics
                            projectLoader={this.state.projectLoader}
                            projects={this.state.projects}
                            getProjectsData={this.getProjectsData}
                            promptCredits={this.state.promptCredits}
                            available_credits={this.state.available_credits}
                            balanceLoader={this.state.balanceLoader}
                            getCreditsLoader={this.state.getCreditsLoader}
                            updateExistingPrompts={this.state.updateExistingPrompts}
                            alreadyTrackedPrompts={this.state.alreadyTrackedPrompts}
                        />
                    </div>
                    {this.state.type === 'manual' && (
                        <div style={{ display: this.state.type === 'manual' ? 'block' : 'none' }}>
                            <AiTrackingAdd
                                prompts={this.initialPrompts}
                                defaultSelectedProject={
                                    this.projectId ? Number(this.projectId) : null
                                }
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default withTranslation()(AiTrackingPromptGenerator);
